import logUtil from 'utils/log'
import logEventWithPrefixAnalyticsUtil from 'utils/analytics/log-event-with-prefix'
import updateCurrentProductIdAction from 'modules/product/redux/actions/update-current'
import updateCurrentVariantIdAction from 'modules/variant/redux/actions/update-current'
import addProductAndVariantIdToUrlProductUtil from 'modules/product/utils/add-product-and-variant-id-to-url'
import updateSelectedColorVariantIdVariantAction from 'modules/variant/redux/actions/update-selected-color-variant-id'
import scrollToTopQuickShopUtil from 'containers/QuickShopProductSidebar/utils/scroll-to-top'
import openQuickShopSidebarProductAction from 'modules/product/redux/actions/open-quick-shop-product-sidebar'
import isFullSizeVariantUtil from 'modules/variant/utils/is-full-size'
import getCurrentDataSidebarSelect from 'modules/sidebar/redux/selectors/get-current-data'
import { GIFT_ENDPOINT } from 'modules/gift/constants'
import isProductUrlLocationUtil from 'utils/location/is-product-url'
import updateHandleUrlProductUtil from 'modules/product/utils/update-handle-url'
import scrollToTopDomUtil from 'utils/dom/scroll-to-top'

const ANALYTICS_EVENT = {
  VIEW_PERFECT_YOUR_LOOK_PRODUCT: 'VIEW_PERFECT_YOUR_LOOK_PRODUCT'
}

/**
 * @param analyticEventPrefix
 * @param debugProps
 * @param {ProductVariantCollection} variantToUse
 * @param variantId
 * @returns {Promise<(function(*, *): void)|*>}
 */
const handleClickQuickShopProductSidebarUseItWithProductAction = ({
  analyticEventPrefix,
  debugProps,
  variantToUse,
  variantId
}) => {
  return (dispatch, getState) => {
    const data = getCurrentDataSidebarSelect(getState())

    const logEvent = (event) => {
      logEventWithPrefixAnalyticsUtil(analyticEventPrefix, event)
    }

    logEvent(ANALYTICS_EVENT.VIEW_PERFECT_YOUR_LOOK_PRODUCT)

    const newDebugProps = {
      ...debugProps,
      data
    }
    logUtil('handleClickQuickShopProductSidebarUseItWithProductAction').debug('newDebugProps=', newDebugProps)

    const productId = variantToUse?.product_id
    const isFullSize = isFullSizeVariantUtil(variantToUse)

    const isProductPage = isProductUrlLocationUtil()

    if (!isProductPage) {
      dispatch(
        openQuickShopSidebarProductAction({
          ...data,
          isFullSize: isFullSizeVariantUtil(variantToUse),
          endpoint: isFullSize
            ? GIFT_ENDPOINT.FULL_SIZE_PRODUCTS
          // `getEndpointLoadFromUrlProductActionUtil` will handle this
            : null
        })
      )
    }

    // TODO migrate to util
    const handle = variantToUse?.handle
    if (isProductPage && handle) {
      logUtil('handleClickQuickShopProductSidebarUseItWithProductAction#updateCurrentProduct').debug('adding handle to url')
      updateHandleUrlProductUtil({ handle })
    }

    dispatch(updateCurrentProductIdAction(productId))
    dispatch(updateCurrentVariantIdAction(variantId))

    addProductAndVariantIdToUrlProductUtil({
      productId,
      variantId
    })

    if (isProductPage) {
      scrollToTopDomUtil()
    } else {
      scrollToTopQuickShopUtil()
    }

    dispatch(
      updateSelectedColorVariantIdVariantAction({
        variantId: (
          variantToUse?.variant_id ||
          variantId
        ),
        shouldUpdateMediaGallery: true,
        shouldAddToUrl: false,
        caller: 'handleClickQuickShopProductSidebarUseItWithProductAction',
        fromSidebar: true
      })
    )
  }
}

export default handleClickQuickShopProductSidebarUseItWithProductAction
